import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import Button from "@/components/Button/Button";
import { combineClasses } from "@/lib/utils";
import styles from "./EventNotFound.module.scss";

const EVENT_NOT_FOUND_LOTTIE = "/lotiee/eventNotFound.json";

interface EventNotFoundProps {
  className?: string;
  title: string;
  titleColor?: "primary" | "default";
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const EventNotFound = ({
  className,
  title,
  titleColor = "default",
  description,
  actionLabel,
  onAction,
}: EventNotFoundProps) => {
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetch(EVENT_NOT_FOUND_LOTTIE)
      .then((response) => response.json())
      .then((data) => {
        if (isMounted) {
          setAnimationData(data);
        }
      })
      .catch(() => {
        if (isMounted) {
          setAnimationData(null);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className={combineClasses(styles.container, className)}>
      <div className={styles.lottieContainer}>
        {animationData ? (
          <Lottie animationData={animationData} className={styles.lottie} loop />
        ) : (
          <div aria-hidden className={styles.lottiePlaceholder} />
        )}
      </div>

      <h2
        className={combineClasses(
          styles.title,
          titleColor === "primary" ? styles.titlePrimary : styles.titleDefault,
        )}
      >
        {title}
      </h2>

      {description ? <p className={styles.description}>{description}</p> : null}

      {actionLabel && onAction ? (
        <div className={styles.actionWrap}>
          <Button className={styles.actionButton} large onClick={onAction} outlined type="button">
            {actionLabel}
          </Button>
        </div>
      ) : null}
    </section>
  );
};

export default EventNotFound;
